import clsx from 'clsx'
import React, { useRef } from 'react'
import {Link} from 'react-router-dom'
import {useDrag, useDrop} from 'react-dnd'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {faBars, faTrashAlt} from "@fortawesome/free-solid-svg-icons"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import AddQuestion from './add-question'
import {isValidQuestion} from 'helpers/quiz'
import {truncateText} from 'helpers/utils'

const verticalCentering = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}

const useStyles = makeStyles(theme => ({
  question: {
    display: 'flex',
    cursor: 'pointer',
    borderBottom: 'solid 1px #c6d6e5',
    backgroundColor: '#f2f9ff',
    '&:hover': {
      backgroundColor: '#c7dcef',
    },
    '&.selected': {
      color: '#fff',
      backgroundColor: '#4cadff',
    },
  },
  questionLink: {
    flexGrow: 1,
    textDecoration: 'none',
    color: '#69738c',
    '&.selected': {
     color: '#fff',
    },
    display: 'flex',
    '& > div': {...verticalCentering},
    '& > .index': {
      padding: '12px 8px',
    },
    '& > .label': {
      padding: '8px 0',
      maxWidth: 200,
      overflow: 'hidden',
      flexGrow: 1
    },
    '& > .sorter': {
      backgroundColor: '#e2eff8',
      padding: 8,
      color: '#abbecd'
    },
    '& > .delete': {
      marginLeft: 5,
      marginRight: 8
    },
    '&.invalid': {
      '& > .label': {
        color: 'red'
      }
    }
  },
  recentlyCreated: {
    fontWeight: 'bold'
  }
}))

export default function Question (props) {

  const classes = useStyles()
  const {context, section, index, question, onDeleteQuestion, onQuestionMove, onQuestionDropped} = props
  const {name: typeName} = context.quizQuestionTypes.find(t => t.id == question.type) || {}
  const {id, opened} = question
  const {translate} = context
  const truncate = truncateText(69)

  const ref = useRef(null)
  const [, drop] = useDrop({
    accept: 'QUESTION',
    hover(item, monitor) {

      if (!ref.current) return

      const dragIndex = item.index
      const hoverIndex = index

      if (dragIndex === hoverIndex) return

      const hoverBoundingRect = ref.current.getBoundingClientRect()
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2
      const clientOffset = monitor.getClientOffset()
      const hoverClientY = clientOffset.y - hoverBoundingRect.top
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return

      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return

      onQuestionMove && onQuestionMove({index: dragIndex, section: item.section}, {index: hoverIndex, section: section.id})
      item.section =  section.id
      item.index = hoverIndex
    },
    drop(item, monitor) {
      !monitor.didDrop() && onQuestionDropped && onQuestionDropped()
    }
  })

  const [{ isDragging }, drag, preview] = useDrag({
    item: { type: 'QUESTION', index, section: section.id}, 
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  })

  preview(drop(ref))

  const opacity = isDragging ? 0 : 1

  const selected = context.questionId == id
  const questionIndex = index + 1
  const questionLabel = truncate(`${question.textpremise || translate(typeName)}`)
  const link = context.link({questionId: question.id, sectionId: question.section}, `/:languageId/:role/:page/:assessment/edit/:sectionId/:questionId`)

  const invalid = !question.isNew && !isValidQuestion(question, typeName)

  return (
    <Box id={id} ref={ref} style={{opacity}} className={clsx(classes.question, {selected})}>
      <Link className={clsx(classes.questionLink, {selected, invalid})} to={link}>
        <Box className="sorter" ref={drag}><FontAwesomeIcon icon={faBars} /></Box>
        <Box className="index">{questionIndex}.</Box>
        <Box className={clsx("label", {[classes.recentlyCreated]: question.isNew})}>{questionLabel}</Box>
        <Box className="delete" onClick={e => {
          e.stopPropagation()
          e.preventDefault()
          onDeleteQuestion && onDeleteQuestion(question)
        }}><FontAwesomeIcon icon={faTrashAlt} /></Box>
      </Link>
    </Box>
  )
}
